import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Api from '../helpers/api';
import { ERROR_NO_CONNECTION } from '../const/error';

/**
 * @type {import('../types').TableHashHook}
 */
const initialValue = {
  tableHash: '',
  anonymous: false,
  exists: false,
  qrTable: {},
  transactions: [],
  settings: {},
  loading: true,
  errorMessage: null,
};

/**
 * @constant
 * @type {import('react').Context<import('../types').TableHashHook>}
 */
const TableHashDataContext = createContext(initialValue);

export const useTableHashData = () => useContext(TableHashDataContext);

const fetchData = async (tableHash, setter) => {
  const api = new Api();

  try {
    const tableData = await api.getTableData(tableHash);

    setter({
      ...initialValue,
      ...tableData,
      tableHash,
      exists: tableData.exists ?? true,
      anonymous: tableData.anonymous ?? false,
      loading: false,
    });
  } catch (e) {
    setter({
      ...initialValue,
      tableHash,
      loading: false,
      errorMessage: ERROR_NO_CONNECTION,
    });
  }
};

export function TableHashDataProvider({ children }) {
  const { query } = useRouter();
  const { tableHash } = query;

  const [value, setValue] = useState({ ...initialValue, tableHash });

  useEffect(() => {
    if (!tableHash) {
      return;
    }

    fetchData(tableHash, setValue);
  }, [tableHash]);

  return <TableHashDataContext.Provider value={value}>{children}</TableHashDataContext.Provider>;
}

TableHashDataProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
